import { COLOURS } from '@shootsta/common-react';

export const STATUS_COLOR_V2 = {
  DRAFT: COLOURS.grey.sterling,
  IN_PROGRESS: COLOURS.yellow.goldenTainoi,
  AWAITING_ACTION: COLOURS.pink.internalPink,
  REQUIRES_ACTION: COLOURS.red.redApple,
  ON_HOLD: '#D6161D',
  COMPLETE: COLOURS.cyan.jungleGreen.monkey,
  SIGN_OFF_FINAL: '#FF3266'
};

export default {
  DRAFT: COLOURS.grey.regent,
  IN_PROGRESS: COLOURS.userComment.unsafeOchre,
  AWAITING_ACTION: COLOURS.red.redApple,
  ON_HOLD: COLOURS.red.redApple,
  COMPLETE: COLOURS.cyan.jungleGreen.monkey,
  SIGN_OFF_FINAL: '#FF3266'
};
